import React, { useEffect, useState, useContext } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap'; 
import ObservatorySidebar from './ObservatorySidebar';
import NavBar from '../NavBar';
import { useParams } from 'react-router';
import { getPageByCode, getPagesByLang } from '../admin/apiCalls';

export default function Observatory() {

  let { pagecode } = useParams();

  const [pageContent, setPageContent] = useState({});

  useEffect(() => {
    if ( pagecode ) {
      getPageByCode(pagecode, (resp) => {
        setPageContent(resp);
      });
    } else {
      getPagesByLang( 'es', (response) => {
        setPageContent(JSON.parse(response)[0]);
        pagecode = JSON.parse(response)[0]['_id'];
      });
    }
  }, [pagecode]);

  return (
    <>
    <NavBar />
    <Container fluid style={{'margin-top': '30px', 'margin-bottom': '30px'}}>
      <Row>
          <Col xs={2} >
            <ObservatorySidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <Card>
              <Card.Body><p><div dangerouslySetInnerHTML={{__html: pageContent && pageContent.content}} /></p></Card.Body>
            </Card>
          </Col> 
      </Row>
    </Container>
    </>
  )
}
